export default __webpack_public_path__ + "static/media/show-transaction-eye.543e2abd.svg";